'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setIn2 = require('./internal/_setIn');

var _setIn3 = _interopRequireDefault(_setIn2);

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Set the `value` at `keyPath` in a nested structure.
 *
 * @example
 * setIn(['one', 'two'], 3, {one: {two: 2}});
 * // returns {one: {two: 3}}
 *
 * @example <caption>Unset keyPaths will be set based on the most recent type.</caption>
 * setIn(['one', 'two'], 3, {});
 * // returns {one: {two: 3}}
 *
 * setIn(['one', 'two'], 3, Map());
 * // returns Map { one => Map { two => 3 } }
 *
 * @param {Array<any>|Iterable<any>} keyPath
 * @param {any} value
 * @param {Array|Iterable|Object} subject
 * @param {Array|Iterable|Object}
 */
exports.default = (0, _curry2.default)(_setIn3.default);
module.exports = exports['default'];